export default {
    updateFreeRenderData: ( state, payload ) => {
		state.freeRenderData = payload;
	}
}